module.exports = __webpack_public_path__ + "img/a2.28e1e215.jpg";